import React from "react";
import { Link } from "react-router-dom";

import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import {
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { BaseButtonProps } from "./types";

import "./styles.css";

const BaseButton = ({
  to,
  onClick,
  variant = BUTTON_VARIANTS.PRIMARY,
  size = BUTTON_SIZES.LARGE,
  type = BUTTON_TYPES.BUTTON,
  target,
  leadingIcon,
  trailingIcon,
  children,
  className,
  state,
  disabled = false,
  loading = false,
  isFullWidth = false,
  ariaLabel,
  ariaPressed,
  ariaDescribedBy,
}: BaseButtonProps) => {
  if (loading && !leadingIcon) {
    leadingIcon = <BaseSpinner size="extra-small" color="white" />;
  }

  const classes = `body-s-regular base-button flex items-center justify-center gap-200 base-button-${variant} base-button-${size} ${disabled || loading ? "base-button-disabled" : ""} ${isFullWidth ? "base-button-full-width" : ""} ${className || ""}`;

  const content = (
    <>
      {leadingIcon && <span>{leadingIcon}</span>}
      {children && <span>{children}</span>}
      {trailingIcon && <span>{trailingIcon}</span>}
    </>
  );

  if (type === BUTTON_TYPES.LINK && to) {
    return (
      <Link
        // @ts-expect-error -1 can be provided to go back
        to={to}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        className={`${classes}`}
        onClick={onClick}
        state={state}
        aria-label={ariaLabel}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      className={classes}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      aria-describedby={ariaDescribedBy}
      aria-disabled={disabled || loading}
      onClick={disabled || loading ? (e) => e.stopPropagation() : onClick}
    >
      {content}
    </button>
  );
};

export default BaseButton;
